import { styled } from "styled-components";

export const LinkText = styled.span`
  color: #00e;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 400;
`;
